import React, { CSSProperties } from 'react';
import { Button } from 'antd';
import { t } from '../../../utils';

export const ClearSignatureButton = ({ onClick }) => {
	const style: CSSProperties = {
		position: 'absolute',
		right: 0,
		border: 0,
		textDecoration: 'underline',
		textTransform: 'capitalize',
		top: '30px',
		cursor: 'pointer',
	};

	return (
		<Button type="link" onClick={onClick} style={style}>
			{t('clear')}
		</Button>
	);
};
